import HttpClient from "./httpClient";
import { API_URLS } from "../utils/apiUrls";

class AuthApi extends HttpClient {
    protected url;

    constructor() {
        super();
        this.url = API_URLS;
    }

    public checkAuth = (email: string) => 
        this.get(this.url.AUTH_CHECK, {}, { email });

    public getUserMsp = (email: string) => 
        this.get(this.url.AUTH_USER_MSP, {}, { email });

    public getPsaStatus = (email: string) => 
        this.get(this.url.AUTH_PSA_STATUS, {}, { email });

    public testAutotaskConnection = (credentials: {
        endpoint: string;
        apiUsername: string;
        apiPassword: string;
        apiIntegrationCode: string;
    }) => 
        this.post(this.url.AUTH_TEST_AUTOTASK, {}, credentials);

    public saveAutotaskConfiguration = (credentials: {
        endpoint: string;
        apiUsername: string;
        apiPassword: string;
        apiIntegrationCode: string;
    }) => 
        this.post(this.url.AUTH_SAVE_AUTOTASK, {}, credentials);

    public testHaloConnection = (credentials: {
        client_id: string;
        client_secret: string;
        url: string;
    }) => 
        this.post(this.url.AUTH_TEST_HALO, {}, credentials);

    public testHaloRequiredPermissions = (credentials: {
        client_id: string;
        client_secret: string;
        url: string;
    }) =>
        this.post(this.url.AUTH_TEST_HALO_PERMISSIONS, {}, credentials);

    public saveHaloConfiguration = (credentials: {
        client_id: string;
        client_secret: string;
        url: string;
    }) => 
        this.post(this.url.AUTH_SAVE_HALO, {}, credentials);

    public testConnectWiseConnection = (credentials: {
        base_url: string;
        company_id: string;
        public_key: string;
        private_key: string;
    }) =>
        this.post(this.url.AUTH_TEST_CONNECTWISE, {}, credentials);

    public saveConnectWiseConfiguration = (credentials: {
        base_url: string;
        company_id: string;
        public_key: string;
        private_key: string;
    }) =>
        this.post(this.url.AUTH_SAVE_CONNECTWISE, {}, credentials);

    public testSuperOpsConnection = (credentials: {
        token_key: string;
        subdomain: string;
        graphql_url?: string;
    }) =>
        this.post(this.url.AUTH_TEST_SUPEROPS, {}, credentials);

    public saveSuperOpsConfiguration = (credentials: {
        token_key: string;
        subdomain: string;
        graphql_url?: string;
    }) =>
        this.post(this.url.AUTH_SAVE_SUPEROPS, {}, credentials);

    public testITGlueConnection = (credentials: {
        api_key: string;
        base_url: string;
    }) =>
        this.post(this.url.AUTH_TEST_ITGLUE, {}, credentials);

    public saveITGlueConfiguration = (credentials: {
        api_key: string;
        base_url: string;
    }) =>
        this.post(this.url.AUTH_SAVE_ITGLUE, {}, credentials);

    public testNableConnection = (credentials: {
        api_key: string;
        base_url: string;
    }) =>
        this.post(this.url.AUTH_TEST_NABLE, {}, credentials);

    public saveNableConfiguration = (credentials: {
        api_key: string;
        base_url: string;
    }) =>
        this.post(this.url.AUTH_SAVE_NABLE, {}, credentials);

    public testNinjaOneConnection = (credentials: {
        client_id: string;
        client_secret: string;
        instance_url: string;
        refresh_token: string;
    }) =>
        this.post(this.url.AUTH_TEST_NINJAONE, {}, credentials);

    public saveNinjaOneConfiguration = (credentials: {
        client_id: string;
        client_secret: string;
        instance_url: string;
        refresh_token: string;
    }) =>
        this.post(this.url.AUTH_SAVE_NINJAONE, {}, credentials);

    public testDattoConnection = (credentials: {
        api_url: string;
        api_key: string;
        api_secret_key: string;
    }) =>
        this.post(this.url.AUTH_TEST_DATTO, {}, credentials);

    public saveDattoConfiguration = (credentials: {
        api_url: string;
        api_key: string;
        api_secret_key: string;
    }) =>
        this.post(this.url.AUTH_SAVE_DATTO, {}, credentials);
}

export default AuthApi;
export const authApi = new AuthApi();
